<template>
  <MRow :gutter="0" class="mt-4">
    <template v-if="resource.movementType === 'asset_transfer'">
      <MCol :size="3">
        <FlotoDepartmentPicker
          :value="value.fromDepartment"
          :placeholder="fromDepartmentIsDisabled ? '---' : undefined"
          :disabled="fromDepartmentIsDisabled"
          :as-input="false"
          @change="handleChange({ fromDepartment: $event })"
        >
          <template v-slot:trigger="slotData">
            <FlotoDropdownTrigger
              v-bind="slotData"
              :lable="`${$tc('from')} ${$tc('department')}`"
              icon-name="building"
              :disabled="fromDepartmentIsDisabled"
            />
          </template>
        </FlotoDepartmentPicker>
      </MCol>
      <MCol :size="3">
        <FlotoDepartmentPicker
          :value="value.toDepartment"
          :placeholder="toDepartmentIsDisabled ? '---' : undefined"
          :disabled="toDepartmentIsDisabled"
          :as-input="false"
          @change="handleChange({ toDepartment: $event })"
        >
          <template v-slot:trigger="slotData">
            <FlotoDropdownTrigger
              v-bind="slotData"
              :lable="`${$tc('to')} ${$tc('department')}`"
              icon-name="building"
              :disabled="toDepartmentIsDisabled"
            />
          </template>
        </FlotoDepartmentPicker>
      </MCol>
    </template>
    <MCol v-if="resource.movementType !== 'asset_transfer'" :size="3">
      <VendorPicker
        :value="value.vendorId"
        :placeholder="disabled ? '---' : undefined"
        disabled
        :as-input="false"
        @change="handleChange({ vendorId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="$tc('vendor')"
            icon-name="user"
            disabled
          />
        </template>
      </VendorPicker>
    </MCol>
    <MCol :size="3">
      <AssetMovementReturnableTypePicker
        :value="value.returnableType"
        :placeholder="disabled ? '---' : undefined"
        disabled
        :type="resource.movementType"
        @change="handleChange({ returnableType: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="$tc('returnable_type')"
            icon-name="diagnosis"
            disabled
          />
        </template>
      </AssetMovementReturnableTypePicker>
    </MCol>
    <MCol
      v-if="
        ['send_to_repair'].indexOf(value.movementType) >= 0 ||
        (['asset_transfer'].indexOf(value.movementType) >= 0 &&
          resource.returnableType === 'temporary_transfer')
      "
      :size="3"
    >
      <FlotoTriggerView
        icon-name="calendar-alt"
        :lable="`${$tc('expected_return_date')}`"
        :value="
          !value.expectedDate
            ? '---'
            : value.expectedDate | datetime(undefined, false)
        "
      />
    </MCol>
  </MRow>
</template>
<script>
import VendorPicker from '@components/data-picker/vendor-picker'
import AssetMovementReturnableTypePicker from '@components/data-picker/asset-movement-returnable-time-picker'
export default {
  name: 'SecondaryRow',
  components: { VendorPicker, AssetMovementReturnableTypePicker },
  model: {
    event: 'change',
  },
  props: {
    disabled: { type: Boolean, default: false },
    value: { type: Object, required: true },
    resource: { type: Object, required: true },
    isDraft: { type: Boolean, defaul: false },
    isTransferReceived: { type: Boolean, defaul: false },
  },
  data() {
    return {}
  },
  computed: {
    fromDepartmentIsDisabled() {
      if (this.value.movementType === 'asset_transfer') {
        if (this.value.toDepartment) {
          return this.disabled || !this.isDraft
        }
        return true
      }
      return this.disabled
    },
    toDepartmentIsDisabled() {
      if (this.value.movementType === 'asset_transfer') {
        if (this.value.fromDepartment) {
          return this.disabled || this.isTransferReceived
        }
        return true
      }
      return this.disabled
    },
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>
